
import { Observable, from, of } from 'rxjs';

import { tap } from 'rxjs/operators';
/**
 * GuardService - implements CanActivate hook for the protected route
 */

//Core
import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';

import _get from 'lodash-es/get';

//Service
import { AuthService } from 'libraries/service/auth/auth.service';
import { PermissionResourceService } from "libraries/service/resources/permission/permissionResource.service";

@Injectable()
export class GuardService implements CanActivate {

    private appPath: string = "";
    private readonly lsPrefix: string = sessionStorage.getItem("$instance_url");

    constructor(private readonly router: Router,
        private readonly authService: AuthService,
        private readonly permissionService: PermissionResourceService) {
    }


    /**
     * canActivate method used in routingModule
     */
    public canActivate(activatedRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const url: string = state.url;

        this.appPath = url.split('/')[1];

        const permissionPath: string = _get(activatedRoute, 'data.permissionPath');
        const redirectTo: string = _get(activatedRoute, 'data.redirectTo');

        this.authService.redirectUrl = url; // set url in authService here

        if (permissionPath) { // if permission is needed
            if (this.checkLogin(url)) {
                return this.permissionService.hasPermission(permissionPath).pipe(
                    tap((hasPermission: boolean) => {
                        if (!hasPermission) {
                            this.router.navigate(redirectTo ? [redirectTo] : ['/']); // if user dont have permission
                        }
                    }));
            }
        }

        // If Locobook,
        if (this.appPath === 'locobook' && !this.authService.checkTokenExp()) {
            this.authService.login("", true);
            return of(true);
        }

        if (this.authService.checkTokenExp()) {
            return of(true);
        }

        this.router.navigate(['/login']); // then ask user to login

        return of(false);
    }

    /**
     * verify if the user is already logged
     * if not : the request url is stored, then redirection to "login" page
     */
    public checkLogin(url: string): boolean {

        // If logged, return
        if (this.authService.checkTokenExp()) {
            return true;
        }

        return false;

    }

}
